module.exports = __webpack_public_path__ + "img/inst.e6f4f8e2.svg";